export default __webpack_public_path__ + "static/media/staking light mode.a8effa22.png";